import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { gameSectionStore } from "../stores/gamesSection";
import { gameStore } from "../stores/games";
import { blackListWithdrawalsStore } from "../stores/blackListWithdrawals";
import { blackListWithdrawalsAddModalStore } from "../stores/blackListWithdrawalsAddModal";
/* ------- */

class BlackListWithdrawalsAddModal extends React.Component {
	componentDidUpdate(prevProps) {
		if (!prevProps.blackListWithdrawalsAddModal.show && this.props.blackListWithdrawalsAddModal.show) {
			this.resetFormFields();
		}
	}

	resetFormFields = () => {
		this.props.setBlackListWithdrawalsAddModal({
			...this.props.blackListWithdrawalsAddModal,
			wallet: '',
			loaded: true
		});
	};


	addBlackListWithdrawal() {
		const data = {
			wallet: this.props.blackListWithdrawalsAddModal.wallet,
			description: this.props.blackListWithdrawalsAddModal.description
		}
		this.props.Interface.request("set", {
			class: "data",
			module: "blackListWithdrawals",
			method: "add"
		}, { ...data }).then((result) => {
			this.props.Interface.addNoty("Success", "Create black list was success");
			this.props.setBlackListWithdrawalsAddModal({ ...this.props.blackListWithdrawalsAddModal, show: false});
			this.props.Interface.loadBlackListWithdrawals();
		}).catch((error) => {
			if (typeof error.text === "undefined") error = { text: error.toString() };
			this.props.setBlackListWithdrawal({ ...this.props.blackListWithdrawal, loaded: true, error });
		})
	}

	updateParam(key, value) {
		let params = cloneDeep(this.props.blackListWithdrawalsAddModal);
		params[key] = value;
		this.props.setBlackListWithdrawalsAddModal({ ...params });
	}

	render() {
		return (
			<>
				<Modal
					visible={this.props.blackListWithdrawalsAddModal.show}
					onDismiss={() => {
						this.props.setBlackListWithdrawalsAddModal({ ...this.props.blackListWithdrawalsAddModal, show: false });
					}}
					header="Add wallet to black list"
					children={
						<>
							<SpaceBetween direction="vertical" size="m">
								<Input
									autoFocus="true"
									name="Name"
									autoComplete="off"
									inputMode="text"
									type="text"
									disableBrowserAutocorrect={true}
									placeholder="Wallet"
									value={this.props.blackListWithdrawalsAddModal.wallet}
									onChange={(input) => {
										this.props.setBlackListWithdrawalsAddModal({ ...this.props.blackListWithdrawalsAddModal, wallet: input.detail.value });
									}}
								/>
								<Input
									autoFocus="true"
									name="Description"
									autoComplete="off"
									inputMode="text"
									type="text"
									disableBrowserAutocorrect={true}
									placeholder="Description"
									value={this.props.blackListWithdrawalsAddModal.description}
									onChange={(input) => {
										this.props.setBlackListWithdrawalsAddModal({ ...this.props.blackListWithdrawalsAddModal, description: input.detail.value });
									}}
								/>
							</SpaceBetween>
						</>
					}
					footer={
						<>
							<Box
								float="right"
								children={
									<>
										<Box
											variant="span"
											margin={{ right: "s" }}
											children={
												<Button
													variant="normal"
													onClick={() => {
														this.props.setBlackListWithdrawalsAddModal({ ...this.props.blackListWithdrawalsAddModal, show: false });
													}}
													children="Close"
												/>
											}
										/>
										<Box
											variant="span"
											children={
												<Button
													disabled={this.props.blackListWithdrawalsAddModal.wallet === ""}
													variant="primary"
													onClick={() => {
														this.addBlackListWithdrawal();
													}}
													children="Ok"
												/>
											}
										/>
									</>
								}
							/>
						</>
					}
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const blackListWithdrawalsAddModal = useRecoilValue(blackListWithdrawalsAddModalStore);
		const setBlackListWithdrawalsAddModal = useSetRecoilState(blackListWithdrawalsAddModalStore);
		const blackListWithdrawal = useRecoilValue(blackListWithdrawalsStore);
		const setBlackListWithdrawal = useSetRecoilState(blackListWithdrawalsStore);
		const config = useRecoilValue(configStore);
		return <Component {...props}  blackListWithdrawalsAddModal={blackListWithdrawalsAddModal} setBlackListWithdrawalsAddModal={setBlackListWithdrawalsAddModal} blackListWithdrawal={blackListWithdrawal} setBlackListWithdrawal={setBlackListWithdrawal} config={config} />;
	};
}

export default withRecoil(BlackListWithdrawalsAddModal);
